import { HTTP } from '@/API/base/client'

/**
 * Get a user's profile details
 * @param  {String} userId              User ID to fetch details for
 * @return {Response}                   200 response
 */
export const getProfile = (userId) => {
  return HTTP.get(`/careers/users/${userId}/profile`)
}

/**
 * Patch to user profile API with updates
 * @param  {String} userId              User ID to update
 * @param  {Object} updateFields        Object containing profile fields to update
 * @return {Response}                   200 response
 */
export const updateProfile = (userId, updateFields) => {
  if (!userId || !Object.keys(updateFields).length) {
    return {}
  }
  return HTTP.patch(`/careers/users/${userId}/profile`, updateFields)
}
